import React from 'react'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_EXISTENCIA_DIARIA_VARIEDAD } from '../../../config/tables'

function ExistenciaDiariaPorVariedad () {
  return (
    <MuiTable id={TABLA_EXISTENCIA_DIARIA_VARIEDAD} />
  )
}

export default ExistenciaDiariaPorVariedad
